import { makeHttpRequest } from "@/shared";

export const deleteKits = async (ids) => {
    return (
        await makeHttpRequest({
            url: "/kit/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;
};
